import { ApparentAgeFilterPopover } from './body-attributes/ApparentAgeFilterPopover';
import { ApparentGenderFilterPopover } from './body-attributes/ApparentGenderFilterPopover';
import { BackpackFilterPopover } from './body-attributes/BackpackFilterPopover';
import { HeadWearFilterPopover } from './body-attributes/HeadwearFilterPopover';
import { LowerAttributesFilterPopover } from './body-attributes/LowerAttributesFilterPopover';
import { ShoesFilterPopover } from './body-attributes/ShoesFilterPopover';
import { UpperAttributesFilterPopover } from './body-attributes/UpperAttributesFilterPopover';
import { ComparingAttributeFilterPopover } from './comparing-attributes/ComparingAttributeFilterPopover';
import { TopSimilarObjectsFilterPopover } from './comparing-attributes/TopSimilarObjectIdsFilterPopover';
import { AgeFilterPopover } from './face-attributes/AgeFilterPopover';
import { DeepfakeFilterPopover } from './face-attributes/DeepfakeFilterPopover';
import { EmotionsFilterPopover } from './face-attributes/EmotionFilterPopover';
import { FaceIdsFilterPopover } from './face-attributes/FaceIdsFilterPopover';
import { GenderFilterPopover } from './face-attributes/GenderFilterPopover';
import { LivenessFilterPopover } from './face-attributes/LivenessFilterPopover';
import { MasksFilterPopover } from './face-attributes/MasksFilterPopover';
import { ExternalIdFilterPopover } from './face-filter-popovers/ExternalIdFilterPopover';
import { ListsFilterPopover } from './face-filter-popovers/ListsFilterPopover';
import { UserDataFilterPopover } from './face-filter-popovers/UserDataFilterPopover';
import { DateFilterPopover } from './general/DateFilterPopover';
import { HandlersFilterPopover } from './general/HandlersFilterPopover';
import { SimilarityFilterPopover } from './general/SimilarityFilterPopover';
import { VideoSourceFilterPopover } from './general/VideoSourcePopover';
import { LocationFilterPopover } from './location/LocationFilterPopover';

export const Popovers = {
  DateFilterPopover,
  VideoSourceFilterPopover,
  HandlersFilterPopover,
  SimilarityFilterPopover,
  MasksFilterPopover,
  LivenessFilterPopover,
  GenderFilterPopover,
  FaceIdsFilterPopover,
  EmotionsFilterPopover,
  DeepfakeFilterPopover,
  AgeFilterPopover,
  TopSimilarObjectsFilterPopover,
  ComparingAttributeFilterPopover,
  UpperAttributesFilterPopover,
  LowerAttributesFilterPopover,
  ApparentAgeFilterPopover,
  ApparentGenderFilterPopover,
  ShoesFilterPopover,
  HeadWearFilterPopover,
  BackpackFilterPopover,
  LocationFilterPopover,
  ExternalIdFilterPopover,
  ListsFilterPopover,
  UserDataFilterPopover,
};
